<template v-if="$route.meta.breadcrumb || $route.meta.pageTitle">
  <div>
    <div class="breadcrumb-page_title">
      {{ $route.meta.pageTitle }}
    </div>
    <div class="d-flex">
      <b-breadcrumb>
        <b-breadcrumb-item
          v-for="item in $route.meta.breadcrumb"
          :key="item.text"
          :active="item.active"
          :to="item.to"
          :disabled="item.disabled"
          @click="redirect(item.route)"
        >
          {{ item.text !== 'Distribution Settings' ? item.text : '' }}
        </b-breadcrumb-item>
      </b-breadcrumb>
      <b-dropdown
        v-if="$route.name === 'distribution-general'"
        id="scrollingList"
        class="custom-dropdown"
        toggle-class="breadcrumb-dropdown"
        @scroll="handleDropdownScroll"
      >
        <template #button-content>
          <div
            class="text-small"
            @click="toggleOpen"
          >
            {{ $route.params.id.toUpperCase() }}
            <GjIcon
              :class="isOpen ? 'arrow-down-icon' : ''"
              name="ArrowDown"
              size="17"
              style="color:#667C99; font-weight: bold;"
            />
          </div>
        </template>
        <b-dropdown-item
          v-for="item in distributions"
          :key="item.distributionId"
          :active="item.distributionId === $route.params.id.toUpperCase()"
          @click="changeDistribution(item.distributionId)"
        >
          <small :class="item.distributionId === item.distributionId ? 'text-warn' : ''">
            {{ item.distributionId }}
          </small>
        </b-dropdown-item>
      </b-dropdown>
    </div>
  </div>
</template>

<script>
import {
  BBreadcrumb, BBreadcrumbItem,
} from 'bootstrap-vue'

export default {
  components: {
    BBreadcrumb,
    BBreadcrumbItem,

  },
  data() {
    return {
      currentPage: 0,
      // Any state value 2
      selectedState: 2,
      fetchedDistributionIds: [],
      isOpen: false,
    }
  },
  computed: {
    distributions() {
      return this.$store.state.cdn.scrolledDistributions
    },
    pageSize() {
      return this.resultInfo.pageSize || 10
    },
    totalCount() {
      return this.resultInfo.totalCount
    },
    resultInfo() {
      return this.$store.state.cdn.scrolledDistributionsResultInfo
    },
  },
  created() {
    if (this.$route.name === 'distribution-general') {
      this.loadMoreData()
    }
  },
  mounted() {
    this.handleDropdownScroll()
  },
  methods: {
    redirect(route) {
      if (route) {
        this.$router.push({
          name: route,
          params: { id: this.$route.params.id },
        })
      }
    },
    toggleOpen() {
      this.isOpen = !this.isOpen
    },
    handleDropdownScroll() {
      const scrollingList = document.querySelector('.dropdown-menu')
      scrollingList.addEventListener('scroll', this.handleScroll)
    },

    handleScroll(event) {
      const scrollingList = event.target
      const scrollableHeight = scrollingList.scrollHeight - scrollingList.clientHeight
      const scrolledPercentage = (scrollingList.scrollTop / scrollableHeight) * 100

      if (scrolledPercentage >= 80) {
        this.currentPage++
        this.loadMoreData()
      }
    },

    loadMoreData() {
      if (this.currentPage >= Math.ceil(this.totalCount / this.pageSize)) {
        return
      }

      this.$store
        .dispatch('cdn/fetchScrolledDistributions', {
          pageIndex: this.currentPage,
          pageSize: this.pageSize,
          state: this.selectedState,
        })
        .catch(error => {
          this.errorToast(
            error.response?.data?.errors[0]
            || 'Something went wrong while fetching distributions.',
          )
        })
    },

    changeDistribution(id) {
      if (id) {
        this.$router.push({
          name: 'distribution-general',
          params: { id },
        })
      } else {
        this.errorToast('Something went wrong while redirecting to this  distributions.')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/../GjirafaFront/style/theme.scss";

.arrow-down-icon {
  rotate: 180deg;
}
.custom-dropdown {
  ::v-deep {

    .btn {
      height: auto;
      background-color: transparent !important;
      color: $blue !important;
      border: none;
      padding: 0 0 !important;
      margin-bottom: -3px !important;
      font-size: 12px;
      border-radius: 0px;
    }

    .dropdown-item.active {
      background-color: $white;
      color: $blue !important;
      padding: 8px;
    }

    .dropdown-item.active > small {
      font-weight: bolder;
    }

    .dropdown-menu {
      height: auto;
      overflow-y: auto;
      max-height: 250px;
      margin-top: 6px;
      text-align: center;
      min-width: 132px;
    }
  }

}
</style>
